<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    深圳北站<br>
站点介绍<br>
深圳北站位于龙华区，呈南北向布置，在民塘路与留仙大道交汇处。结构形式:地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br>
赤湾	06:07	23:32	5号线	3分钟	5分25秒<br>
黄贝岭	06:09	23:49	5号线	3分钟	5分25秒<br>
科学馆	06:26	23:53	6号线	3分24秒	6分20秒<br>
松岗	06:03	23:18	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br>
赤湾	06:25	23:32	5号线	4分钟	6分钟<br>
黄贝岭	06:06	23:49	5号线	4分钟	6分钟<br>
科学馆	06:34	23:53	6号线	4分45秒	6分钟<br>
松岗	06:03	23:18	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br>
赤湾	06:25	00:32	5号线	4分钟	6分钟<br>
黄贝岭	06:06	00:49	5号线	4分钟	6分钟<br>
科学馆	06:34	00:53	6号线	4分45秒	6分钟<br>
松岗	06:03	00:18	6号线	4分45秒	6分钟<br><br>

站点出口信息<br><br>
北端出入口（连接公交车站）:<br>
创业花园、留仙大道、彩悦酒店 、东2停车库<br><br>
东端出入口（连接缤果空间）:<br>
民塘路、梅龙路、铁路桥 、樟坑村<br><br>
南端出入口（连接出租车站）:<br>
东1停车库、新区大道、龙悦居、维也纳酒店、玉龙路<br><br>
西端出入口（连接火车站）:<br>
致远中路、社会停车场、圣莫丽斯、坪山快捷线<br><br>
公交换乘信息<br><br>
北端出入口:<br>
公交站名： 深圳北站交通枢纽公交场站<br>
M217、75、M462、M347、M300、M299、E11、M363、E22、M340、M341、M343、E7、M352、M572、M567、高快巴士24号、M130、G76、B730、M225、M353、M354、E14、M477<br><br>
南端出入口:<br>
公交站名： 深圳北站<br>
B917、M339、M393、M405、M579<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sihaoxian",
          title: "4号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


